import { Box, Chip, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { EasCard } from 'ui/EasCard';
import { selectOrderDetails, selectOrderDetailsLoading } from 'redux/reducers/euDdp/selectors';
import { OrderDetailsRow } from './OrderDetailsRow';

export const OrderDetails: FC = () => {
	const order = useSelector(selectOrderDetails);
	const orderIsLoading = useSelector(selectOrderDetailsLoading);
	const orderDetails = order?.order_details;

	const [detalization, setDetalization] = useState(false);
	const handleDetalization = () => {
		setDetalization(!detalization);
	};

	return (
		<div>
			{!orderIsLoading && !!order ? (
				<EasCard
					id="eu-ddp-order-order-details"
					title="Order Details"
					action={
						<>
							{order.order.values_status && (
								<Chip
									label={order.order.values_status}
									size="small"
									sx={{
										p: '0 1px',
										fontSize: '.7rem',
										height: '20px',
										bgcolor: 'primary.main',
										color: '#ffffff',
									}}
								/>
							)}
							{detalization ? (
								<Tooltip title="Hide more details">
									<IconButton
										size="small"
										color="primary"
										onClick={handleDetalization}
										sx={{ p: 0 }}
									>
										<IndeterminateCheckBoxIcon />
									</IconButton>
								</Tooltip>
							) : (
								<Tooltip title="Show more details">
									<IconButton size="small" color="primary" onClick={handleDetalization}>
										<AddBoxIcon />
									</IconButton>
								</Tooltip>
							)}
						</>
					}
				>
					<Typography variant="h6" component="div">
						{orderDetails?.rows?.map((item) => (
							<OrderDetailsRow
								key={nanoid()}
								orderDetailsRow={item}
								paymentCurrency={order.order.payment_currency}
								detalization={detalization}
							/>
						))}
					</Typography>
					{(orderDetails?.rows?.length ?? 0) > 1 && (
						<Box
							sx={{
								mt: 1.5,
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								border: '1px solid #00000020',
								borderRadius: '12px',
								padding: '10px',
							}}
						>
							<Typography variant="h6" sx={{ fontWeight: 'bold' }} color="primary">
								Total Amount:
							</Typography>
							<AmountAndCurrency
								amount={order.order.total_order_value ?? 0}
								currency={order.order.payment_currency}
								bold="bold"
								size={1.3}
								color="primary"
							/>
						</Box>
					)}
				</EasCard>
			) : (
				<Skeleton variant="rectangular" height="200px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
